import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  metadata: {
    title: "Rupifi API Documentation",
    description: "Rupifi is a B2B digital finance platform that helps the financial growth of small and medium enterprises.",
    logo: "/images/logo-black.png",
    favicon: "/images/favicon.png",
    generator: "Jahangeer Wani",
    applicationName: "Rupifi API Documentation",
    keywords: ["Rupifi API Documentation", "Rupifi", "API", "Docs", "B2B", "BNPL", "Buy Now Pay Later", "Loan"],
    authors: ["Jahangeer Wani"],
    creator: "Jahangeer Wani",
    publisher: "Jahangeer Wani"
  },

  site: {
    title: "Rupifi API Documentation",
    showPoweredBy: false,
    logo: {
      src: {
        light: "/images/logo-black.png",
        dark: "/images/logo-white.png",
      },
      width: "130px",
      alt: "Rupifi Logo",
      href: "/" // Clicking the logo goes bnpl
    },
  },

  navigation: [
    // TAB 1: HOME
    {
      type: "category",
      label: "🏠︎ Home",
      items: [
        {
          type: "doc",
          label: "Overview",
          file: "bnpl/overview",
          path: "/"
        },
        {
          type: "doc",
          label: "API",
          file: "bnpl/api",
        },
        {
          type: "link",
          label: "Support",
          to: "https://rupifi.com/contact",
        }
      ],
    },

    // TAB 2: API
    {
      type: "category",
      label: "🔑 APIs",
      link: { type: "doc", file: "api" },
      items: []
    },

    // TAB 3: DOCUMENTATION
    {
      type: "category",
      label: "📖 Documentation",
      items: [
        {
          type: "category",
          label: "📔 Callbacks",
          items: [
            { type: "doc", label: "Lead Callbacks", file: "documentation/Lead-Callbacks" },
            { type: "doc", label: "Payment Callbacks", file: "documentation/Payment-Callbacks" },
            { type: "doc", label: "Settlement Callbacks", file: "documentation/Settlement-Callbacks" },
            { type: "doc", label: "Repayment Callbacks", file: "documentation/Repayment-Callbacks" },
          ],
        },
        { type: "doc", label: "Order-Flow-Diagram", file: "documentation/Order-Flow-Diagram" },
        { type: "doc", label: "In-app Integration", file: "documentation/In-app-Integration" },
        { type: "doc", label: "Handling UPI Intent in Android & iOS", file: "documentation/UPI-Intent-Android-iOS" },
        { type: "link", label: "🔑 APIs", to: "bnpl/api" },
        {
          type: "link",
          label: "Support",
          to: "https://rupifi.com/contact",
        },
      ],
    },
  ],

  apis: [
    {
      type: "file",
      input: "./apis/bundled.json",
      path: "api",
    },
  ],

  docs: {
    publishMarkdown: false,
    defaultOptions: {
      showLastModified: false,
      copyPage: false,
    },
  },

  theme: {
    light: {
      background: "oklch(100% 0 none)",
      foreground: "oklch(13.7% 0.036 259)",
      card: "oklch(100% 0 none)",
      cardForeground: "oklch(13.7% 0.036 259)",
      popover: "oklch(100% 0 none)",
      popoverForeground: "oklch(13.7% 0.036 259)",
      primary: "oklch(54.6% 0.215 263)",
      primaryForeground: "oklch(98.4% 0.003 248)",
      secondary: "oklch(96.8% 0.007 248)",
      secondaryForeground: "oklch(20.8% 0.04 266)",
      muted: "oklch(96.8% 0.007 248)",
      mutedForeground: "oklch(55.5% 0.041 257)",
      accent: "oklch(96.8% 0.007 248)",
      accentForeground: "oklch(20.8% 0.04 266)",
      destructive: "oklch(63.7% 0.208 25.3)",
      destructiveForeground: "oklch(98.4% 0.003 248)",
      border: "oklch(92.9% 0.013 256)",
      input: "oklch(92.9% 0.013 256)",
      ring: "oklch(54.6% 0.215 263)"
    },
    dark: {
      background: "oklch(13.7% 0.036 259)",
      foreground: "oklch(98.4% 0.003 248)",
      card: "oklch(13.7% 0.036 259)",
      cardForeground: "oklch(98.4% 0.003 248)",
      popover: "oklch(13.7% 0.036 259)",
      popoverForeground: "oklch(98.4% 0.003 248)",
      primary: "oklch(62.3% 0.188 260)",
      primaryForeground: "oklch(20.8% 0.04 266)",
      secondary: "oklch(28% 0.037 260)",
      secondaryForeground: "oklch(98.4% 0.003 248)",
      muted: "oklch(28% 0.037 260)",
      mutedForeground: "oklch(71.1% 0.035 257)",
      accent: "oklch(28% 0.037 260)",
      accentForeground: "oklch(98.4% 0.003 248)",
      destructive: "oklch(39.6% 0.133 25.7)",
      destructiveForeground: "oklch(98.4% 0.003 248)",
      border: "oklch(28% 0.037 260)",
      input: "oklch(28% 0.037 260)",
      ring: "oklch(48.8% 0.217 264)"
    }
  }
};

export default config;